require('../common/assets/styles/main.scss');
import 'babel-core/register';
import 'babel-polyfill';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'mobx-react';
import { BrowserRouter as Router } from 'react-router-dom';
import Actions from '../common/actions';
import RootStore from '../common/stores';
import Routes from '../common/components/routes';
import { AppContainer } from 'react-hot-loader';

const rootStore = new RootStore(window.__INITIAL_STATE__);
const actions = new Actions(rootStore);

const renderApp = Component => {
    render(
        <AppContainer>
            <Provider rootStore={rootStore}>
                <Router path={window.location.pathname}>
                    <Routes actions={actions} />
                </Router>
            </Provider>
        </AppContainer>,
        document.getElementById('root')
    );
};

renderApp(Routes);

if (module.hot) {
    module.hot.accept(() => renderApp(Routes));
}



// WEBPACK FOOTER //
// ./src/client/index.js